import { createStyles } from '@material-ui/core/styles';

import fonts from '../fonts';

export default createStyles({
  root: {
    minWidth: 'fit-content',
    '& .MuiButton-startIcon > *:first-child': {
      fontSize: fonts.sizes.xxlarge,
    },
  },
});
